export const CLEAR_FORM = 'CLEAR_FORM';
export const UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
export const RESET_FORM = 'RESET_FORM';
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
